// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__hlNiu","title":"styles_title__2AaFC"};